import * as React from 'react'
import { Chip } from '@mui/material'
import { FC } from 'react'
import { styled } from '@mui/material/styles'
import { useTranslate } from 'react-admin'

const PREFIX = 'QuickFilter'

const classes = {
  chip: `${PREFIX}-chip`,
}

const StyledChip = styled(Chip)(({ theme }) => ({
  [`&.${classes.chip}`]: {
    marginBottom: theme.spacing(1),
  },
}))

type QuickFilterProps = {
  label: string

  defaultValue?: string
  source?: string
}

export const QuickFilter: FC<QuickFilterProps> = ({ label }) => {
  const translate = useTranslate()
  return <StyledChip className={classes.chip} label={translate(label)} />
}
